import React from "react";
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import logo from "../logo.png";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    preloaderContainer: {
        position: 'relative',
        height: '100vh'
    },
    preloader: {
        width: '100%',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    logo: {
        display: 'block',
        width: '300px',
        height: 'auto',
        padding: 0,
        margin: '-80px auto 12px auto'
    },
}));

export default function Preloader(props) {

    const classes = useStyles(props);

    return <div className={classes.preloaderContainer}>
            <div className={classes.preloader}>
                <img src={logo} className={classes.logo} alt="Sendiio" />
                <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                    <LinearProgress color="primary" />
                </Stack>
            </div>
        </div>

}